<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.22</b> - Исправления ошибок Пещер и Таверны</p>
    <div class="ml-5 pb-4 text-pink-400">
      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>Исправлены сбои рендеринга Пещер, особенно при сворачивании и разворачивании игры.</li>
        <li>
          Исправлено дублирование членства в турнире Таверны для одного и того же подрежима (причина
          несоответствий рангов)
        </li>
        <li>
          Исправлена проблема, когда в журнал боя иногда не добавлялись записи о только что
          завершившихся битвах.
        </li>
      </ul>

      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>
          Снова включена подписка на новостную рассылку
          <span class="text-cyan-400">(за 100 бесплатных ПП!)</span> с улучшенным почтовым сервисом
          - см. окно Пиксельной пыли или окно "Мир" в шапке сайта.
        </li>
      </ul>
    </div>
  </div>
</template>
